import React, { useEffect } from 'react';
import './Notification.css';

export const Notification = ({ message, type = 'info', onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓ Éxito';
      case 'error':
        return '✗ Error';
      case 'warning':
        return '⚠ Advertencia';
      default:
        return 'ℹ Información';
    }
  };

  return (
    <div className={`notification notification-${type}`}>
      <div className="notification-title">{getIcon()}</div>
      <div className="notification-message">{message}</div>
      <button className="notification-close" onClick={onClose}>
        ×
      </button>
    </div>
  );
};

